import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";

const ROLE_LABEL = {
    ceo: "CEO", office_admin: "Office Admin", marketing_executive: "Marketing", agent: "Agent",
    telecaller: "Telecaller", customer: "Customer",
};

export default function Team() {
    const [rows, setRows] = useState([]);
    useEffect(() => {
        (async () => { try { const { data } = await api.get("/users"); setRows(data); } catch {} })();
    }, []);
    return (
        <div className="space-y-6" data-testid="team-page">
            <div>
                <p className="text-[10px] uppercase tracking-[0.28em] text-komma-gold">People</p>
                <h1 className="font-serif text-3xl text-komma-navy">Team Directory</h1>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                {rows.map((u) => (
                    <div key={u.id} className="komma-card p-5" data-testid={`team-${u.id}`}>
                        <div className="flex items-center gap-3">
                            <div className="h-12 w-12 rounded-full bg-komma-navy text-komma-gold flex items-center justify-center font-serif text-xl">
                                {u.name?.[0] || "?"}
                            </div>
                            <div>
                                <p className="font-serif text-lg text-komma-navy">{u.name}</p>
                                <p className="text-xs text-gray-500">{u.email}</p>
                            </div>
                        </div>
                        <div className="komma-gold-hairline my-3" />
                        <div className="flex justify-between items-center">
                            <Badge variant="outline" className="bg-komma-gold/10 border-komma-gold/40 text-komma-navy">{ROLE_LABEL[u.role] || u.role}</Badge>
                            <span className="text-xs text-gray-500">{u.phone || "—"}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
